module.exports = __webpack_public_path__ + "img/star-rect-icon.ac986971.svg";